import { camelCase } from 'lodash-es';
import * as React from 'react';
import { useIntl } from 'react-intl';
import SwitchContainerButton from '../../../../../../molecules/merchant/common/buttons/SwitchContainerButton';
import { SwitchType } from './index';
import css from './SwitchCourseStaff.module.scss';

interface OwnProps {
  selected: SwitchType;
  onClick: (select: SwitchType) => void;
}

type Props = OwnProps;

const SwitchCourseStaff: React.FC<Props> = ({ selected, onClick }) => {
  const intl = useIntl();
  const selections = Object.values(SwitchType);
  return (
    <div className={css.SwitchCourseStaff}>
      {selections.map((selection) => (
        <SwitchContainerButton
          key={selection}
          name="switch"
          id={selection}
          label={intl.formatMessage({
            id: `merchants.bookingPages.switchCourseStaff.${camelCase(
              selection,
            )}`,
          })}
          onChange={(e) => {
            e.preventDefault();
            onClick(selection);
          }}
          checked={selection === selected}
        />
      ))}
    </div>
  );
};

export default SwitchCourseStaff;
